export default class OtherLayerConig {
    constructor(_config) {
        this.layers =[
    
        ]
    }
}